import { render, staticRenderFns } from "./modal-cht-bind.vue?vue&type=template&id=88704a3c"
import script from "./modal-cht-bind.vue?vue&type=script&lang=js"
export * from "./modal-cht-bind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports